import type { ReferralPhoto } from '../../shared/types';

export function PhotoGrid({ photos }: { photos: ReferralPhoto[] }) {
  if (photos.length === 0) {
    return <p className="muted">No photos.</p>;
  }
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(88px, 1fr))',
        gap: '0.5rem',
      }}
    >
      {photos.map((photo) => (
        <a
          key={photo.id}
          href={`/api/photos/${photo.id}`}
          target="_blank"
          rel="noreferrer"
          style={{ display: 'block' }}
        >
          <img
            src={`/api/photos/${photo.id}`}
            alt={photo.kind === 'intake' ? 'Photo from the plumber' : 'Photo from the field'}
            loading="lazy"
            style={{
              width: '100%',
              aspectRatio: '1 / 1',
              height: 'auto',
              objectFit: 'cover',
              borderRadius: 'var(--radius-sm)',
              border: '1px solid var(--line)',
              display: 'block',
            }}
          />
        </a>
      ))}
    </div>
  );
}
